import axios from "axios";
import { API, getDeviceId } from "@/lib/api";

const base = () => `${API}/family/${getDeviceId()}`;
const pinHeader = (pin) => ({ headers: { "X-Parent-Pin": pin } });

export const errorText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(" ");
  return "Something went wrong. Please try again.";
};

export const getFamily = async () => (await axios.get(base())).data;
export const setPin = async (pin, current_pin) => axios.post(`${base()}/pin`, { pin, current_pin });
export const verifyPin = async (pin) => axios.post(`${base()}/verify`, {}, pinHeader(pin));
export const addProfile = async (pin, name, age) => (await axios.post(`${base()}/profiles`, { name, age }, pinHeader(pin))).data;
export const removeProfile = async (pin, id) => axios.delete(`${base()}/profiles/${id}`, pinHeader(pin));

export const setChildVoice = async (pin, id, voice) => (await axios.patch(`${base()}/profiles/${id}/voice`, { voice }, pinHeader(pin))).data;
export const getMembers = async (pin) => (await axios.get(`${base()}/members`, pinHeader(pin))).data;
export const inviteMember = async (pin, email, role) => (await axios.post(`${base()}/invites`, { email, role }, pinHeader(pin))).data;
export const removeMember = async (pin, id) => axios.delete(`${base()}/members/${id}`, pinHeader(pin));
export const joinFamily = async (code) => (await axios.post(`${API}/family-join`, { code })).data;
export const getActiveProfileId = () => localStorage.getItem("pp_profile") || "";
export const setActiveProfileId = (id) => localStorage.setItem("pp_profile", id);
